// import React from "react";
// import React, { useEffect } from "react";
import React, { Fragment, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
// import { BrowserRouter } from "react-router-dom";
import AppRouters from "./routes/AppRouters";
import CookieConsent from "react-cookie-consent";
// import "./index.css";
import "./assets/fonts/exo/exo.css";
import "./assets/fonts/fira-sans/fira-sans.css";
import "slick-carousel/slick/slick.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/fontawesome.css";
import "./assets/scss/style.scss";
import "moment/locale/th";


const getInitialLang = () => {
  if (typeof window === "undefined") return "th";
  return window.localStorage.getItem("cheese_lang") || "th";
};


function App() {
  const [lang, setLang] = useState(getInitialLang);

  // Update on first mount (in case SSR hydration differs)
  useEffect(() => {
    if (typeof window !== "undefined") {
      const v = window.localStorage.getItem("cheese_lang");
      setLang(v || "th");
    }
  }, []);

  // Listen for cross-tab language changes
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onStorage = () => {
      const v = window.localStorage.getItem("cheese_lang");
      setLang(v || "th");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isTH = lang === "th";

  return (
    <BrowserRouter>
      <AppRouters />
      <CookieConsent
        buttonText={isTH ? "ตกลง" : "Accept"}
        buttonStyle={{ background: "var(--theme-color)" }}
      >
        <strong>{isTH ? "เว็บไซต์นี้มีการใช้คุกกี้" : "This website uses cookies."}</strong><br />{isTH ? 
        "โปรดยอมรับนโยบายคุกกี้เพื่อประสบการณ์การใช้บริการที่ดีที่สุดของท่าน ท่านสามารถศึกษาวิธีการตั้งค่าการควบคุมคุกกี้ของท่านผ่านนโยบายการใช้คุกกี้ของเรา" : 
        "Please accept our cookie policy for the best experience. You can learn how to control cookies in our policy."} 
        <a href="/cookie-policy">{isTH ? " อ่านเพิ่มเติม" : " Learn more"}</a>
      </CookieConsent>
    </BrowserRouter>
  );
}

export default App;
